(() => {
  'use strict';
  if (window.__CANFOTO_E1_FINAL1_R2J_E6_PAGE_ARTICLE_LOCAL_CONTRAST__) return;
  window.__CANFOTO_E1_FINAL1_R2J_E6_PAGE_ARTICLE_LOCAL_CONTRAST__ = true;

  const VERSION = 'CANFOTO-E1-FINAL1-R2J-E6-PAGE-ARTICLE-GRADIENT-CONTRAST-RUNTIME-R1';
  const EXCLUDED_PATHS = new Set([
    '/pages/biz-kimiz',
    '/pages/cob-led-secim-motoru',
    '/pages/panel-led-secim-motoru',
    '/pages/led-isik-secim-motoru'
  ]);
  const MIN_RATIO = 4.35;
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const originals = new WeakMap();
  let contentObserver = null;
  let rootObserver = null;
  let timer = 0;
  let running = false;
  let probe = null;

  const state = {
    version: VERSION,
    route: location.pathname,
    status: 'INIT',
    scans: 0,
    fixedCount: 0,
    lastFixed: [],
    excluded: false,
    contextType: 'INIT'
  };
  window.CANFOTO_E1_FINAL1_R2J_E6_CONTENT_CONTRAST_STATE = state;

  function parseColor(v) {
    const s = String(v || '').trim();
    let m = s.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,/]\s*([\d.]+))?\s*\)$/i);
    if (m) return [+m[1], +m[2], +m[3], m[4] == null ? 1 : +m[4]];

    m = s.match(/^color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+))?\)$/i);
    if (m) return [
      Math.max(0, Math.min(255, +m[1] * 255)),
      Math.max(0, Math.min(255, +m[2] * 255)),
      Math.max(0, Math.min(255, +m[3] * 255)),
      m[4] == null ? 1 : +m[4]
    ];

    m = s.match(/^#([0-9a-f]{3,8})$/i);
    if (!m) return null;
    let h = m[1];
    if (h.length === 3 || h.length === 4) h = h.split('').map(x => x + x).join('');
    if (h.length !== 6 && h.length !== 8) return null;
    return [
      parseInt(h.slice(0, 2), 16),
      parseInt(h.slice(2, 4), 16),
      parseInt(h.slice(4, 6), 16),
      h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1
    ];
  }

  function rgbString(c) {
    return `rgb(${Math.round(c[0])}, ${Math.round(c[1])}, ${Math.round(c[2])})`;
  }

  function lum(c) {
    if (!c) return 0;
    return c.slice(0, 3).map(v => {
      v /= 255;
      return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4);
    }).reduce((sum, v, i) => sum + v * [.2126, .7152, .0722][i], 0);
  }

  function ratio(a, b) {
    const A = typeof a === 'string' ? parseColor(a) : a;
    const B = typeof b === 'string' ? parseColor(b) : b;
    if (!A || !B) return 0;
    const la = lum(A), lb = lum(B);
    return (Math.max(la, lb) + .05) / (Math.min(la, lb) + .05);
  }

  function ensureProbe() {
    if (probe?.isConnected) return probe;
    probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    Object.assign(probe.style, {
      position: 'fixed',
      width: '1px',
      height: '1px',
      opacity: '0',
      pointerEvents: 'none',
      left: '-9999px',
      top: '-9999px'
    });
    document.body.appendChild(probe);
    return probe;
  }

  function resolveToken(name) {
    const p = ensureProbe();
    p.style.color = `var(${name})`;
    return getComputedStyle(p).color;
  }

  function gradientSamples(backgroundImage) {
    const s = String(backgroundImage || '');
    if (!s || s === 'none' || !/gradient\(/i.test(s)) return [];

    const raw = [
      ...(s.match(/rgba?\([^)]*\)/gi) || []),
      ...(s.match(/#[0-9a-f]{3,8}\b/gi) || []),
      ...(s.match(/color\(srgb[^)]*\)/gi) || [])
    ];

    const out = [];
    const seen = new Set();
    for (const token of raw) {
      const c = parseColor(token);
      if (!c || c[3] < .75) continue;
      const key = c.slice(0, 3).map(x => Math.round(x)).join(',');
      if (!seen.has(key)) {
        seen.add(key);
        out.push(c);
      }
    }
    return out;
  }

  function visualBackground(el, stop) {
    let n = el;
    while (n && n !== document.documentElement) {
      const cs = getComputedStyle(n);
      const grads = gradientSamples(cs.backgroundImage);
      const solid = parseColor(cs.backgroundColor);

      /* A local gradient is the visual owner even if background-color itself is
         transparent. This is the E5 miss that produced black text on the dark
         "Küresel Genişleme Operasyonları" panel. */
      if (grads.length) {
        if (solid && solid[3] >= .92) grads.push(solid);
        return { owner: n, samples: grads, kind: 'GRADIENT' };
      }

      if (solid && solid[3] >= .92) {
        return { owner: n, samples: [solid], kind: 'SOLID' };
      }

      if (n === stop) break;
      n = n.parentElement;
    }

    const body = parseColor(getComputedStyle(document.body).backgroundColor) || [255,255,255,1];
    return { owner: document.body, samples: [body], kind: 'BODY' };
  }

  function worstRatio(color, samples) {
    const c = typeof color === 'string' ? parseColor(color) : color;
    if (!c || !samples?.length) return 0;
    return Math.min(...samples.map(bg => ratio(c, bg)));
  }

  function visibleTextNode(el) {
    if (!el || !String(el.textContent || '').replace(/\s+/g, ' ').trim()) return false;
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    return true;
  }

  function remember(el) {
    if (originals.has(el)) return;
    originals.set(el, {
      value: el.style.getPropertyValue('color'),
      priority: el.style.getPropertyPriority('color')
    });
  }

  function restore(el) {
    const o = originals.get(el);
    if (!o) return;
    if (o.value) el.style.setProperty('color', o.value, o.priority || '');
    else el.style.removeProperty('color');
    el.removeAttribute('data-cf-page-contrast-fixed');
  }

  function chooseColor(el, samples) {
    const fg = resolveToken('--cf-fg');
    const pageBg = resolveToken('--cf-bg');
    const accent = resolveToken('--cf-accent');
    const accentText = resolveToken('--cf-accent-text');
    const candidates = el.matches('a[href]')
      ? [accent, fg, pageBg, accentText]
      : [fg, pageBg, accentText, accent];

    let best = { color: candidates[0], ratio: -1 };
    for (const c of candidates) {
      const r = worstRatio(c, samples);
      if (r > best.ratio) best = { color: c, ratio: r };
    }

    if (best.ratio < MIN_RATIO) {
      const black = 'rgb(17, 17, 17)', white = 'rgb(255, 255, 255)';
      const rb = worstRatio(black, samples), rw = worstRatio(white, samples);
      best = rb >= rw ? { color: black, ratio: rb } : { color: white, ratio: rw };
    }
    return best;
  }

  function context() {
    const path = location.pathname.replace(/\/$/, '');

    if (document.body.classList.contains('template-page')) {
      if (EXCLUDED_PATHS.has(path)) return { type: 'EXCLUDED', host: null };
      if (q('.gdx-twin-light-gateway,#gdxCobV5Root,#gdx-panel-led-v4-root')) {
        return { type: 'EXCLUDED', host: null };
      }
      return { type: 'PAGE', host: q('#MainContent .page.rte') };
    }

    if (document.body.classList.contains('template-article')) {
      return {
        type: 'ARTICLE',
        host: q('#MainContent article .rte[itemprop="articleBody"],#MainContent .article .rte')
      };
    }

    return { type: 'EXCLUDED', host: null };
  }

  function isExcluded() {
    return context().type === 'EXCLUDED';
  }

  function host() {
    return context().host;
  }

  function scan() {
    if (running) return state;
    running = true;
    try {
      state.route = location.pathname;
      state.contextType = context().type;
      state.excluded = isExcluded();
      if (state.excluded) {
        state.status = 'EXCLUDED_NO_TOUCH';
        state.fixedCount = 0;
        state.lastFixed = [];
        return state;
      }

      const root = host();
      if (!root) {
        state.status = 'NO_PAGE_RTE_HOST';
        state.fixedCount = 0;
        state.lastFixed = [];
        return state;
      }

      const selector = [
        'h1','h2','h3','h4','h5','h6',
        'p','li','dt','dd','blockquote',
        'span','strong','b','em','i','small','label',
        'a[href]','th','td'
      ].join(',');

      const nodes = qa(selector, root).filter(visibleTextNode);
      const fixed = [];

      for (const el of nodes) {
        remember(el);
        restore(el);

        const visual = visualBackground(el, root);
        const fg = getComputedStyle(el).color;
        const before = worstRatio(fg, visual.samples);
        if (before >= MIN_RATIO) continue;

        const picked = chooseColor(el, visual.samples);
        el.style.setProperty('color', picked.color, 'important');
        el.setAttribute('data-cf-page-contrast-fixed', '1');

        fixed.push({
          tag: el.tagName,
          text: String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 72),
          before: Number(before.toFixed(2)),
          after: Number(picked.ratio.toFixed(2)),
          bgKind: visual.kind,
          bgOwner: visual.owner?.tagName || '',
          bgSamples: visual.samples.map(rgbString),
          color: picked.color
        });
      }

      state.scans += 1;
      state.fixedCount = fixed.length;
      state.lastFixed = fixed.slice(0, 40);
      state.status = 'READY';
      document.documentElement.dataset.cfPageContrast = 'E6';
      return state;
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 60);
  }

  function boot() {
    state.excluded = isExcluded();
    if (state.excluded) {
      state.status = 'EXCLUDED_NO_TOUCH';
      return;
    }

    const root = host();
    if (!root) {
      state.status = 'NO_PAGE_RTE_HOST';
      return;
    }

    scan();

    contentObserver = new MutationObserver(schedule);
    contentObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-expanded']
    });

    rootObserver = new MutationObserver(schedule);
    rootObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-cf-theme']
    });
  }

  window.CanFotoContentContrastRuntime = {
    version: VERSION,
    scan,
    state: () => ({ ...state })
  };

  window.CanFotoPageContrastRuntime = window.CanFotoContentContrastRuntime;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
